/* ============
 * Warehouse Transformer
 * ============
 */

import Transformer from './transformer';
import ContactTransformer from './warehouseContact';
import AddressTransformer from './warehouseAddress';

export default class WarehouseTransformer extends Transformer {

  static fetch(warehouse) {
    return {
      id: warehouse.id,
      name: warehouse.name,
      location: warehouse.location,
      isBonded: warehouse.is_bonded,
      isActive: warehouse.is_active,
      isLocked: warehouse.is_locked,
      typeId: warehouse.type_id,
      partnerId: warehouse.partner_id,
      typeName: warehouse.type_name,
      address: warehouse.address !== undefined ? AddressTransformer.fetch(warehouse.address) : [],
      contact: warehouse.contact !== undefined ? ContactTransformer.fetch(warehouse.contact) : [],
      isSharedToYou: warehouse.is_shared_to_you,
      shippingProviders: warehouse.shipping_providers,
    };
  }

  static send(warehouse) {
    return {
      id: warehouse.id,
      name: warehouse.name,
      location: warehouse.location,
      partner_id: warehouse.partnerId,
      is_bonded: warehouse.isBonded,
      is_active: warehouse.isActive,
      first_name: warehouse.firstName,
      last_name: warehouse.lastName,
      email: warehouse.email,
      phone_number: warehouse.phoneNumber,
      street_name_1: warehouse.streetName1,
      street_name_2: warehouse.streetName2,
      country_id: warehouse.countryId,
      city: warehouse.city,
      postal_code: warehouse.postalCode,
      shipping_providers: warehouse.shippingProviders,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/warehouse.js